export function getPositionInElem(
    [clientX, clientY]: [number, number],
    containerElem: Element
): [number, number] {
    const boundingRect = containerElem.getBoundingClientRect();
    return [clientX - boundingRect.left, clientY - boundingRect.top];
}
